import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dropdown",
  "use": "icon-dropdown-usage",
  "viewBox": "0 0 6 4",
  "content": "<symbol viewBox=\"0 0 6 4\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-dropdown\">\r\n<path d=\"M9.5515,5.5986875 L7.284375,8.6069375 C7.1413125,8.796375 6.902,8.7994375 6.7545625,8.6069375 L4.4506875,5.5986875 C4.3019375,5.4044375 4.379375,5.25 4.620875,5.25 L9.377375,5.25 C9.620625,5.25 9.69675,5.4061875 9.5515,5.5986875 L9.5515,5.5986875 Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol